const serverURL = process.env.VUE_APP_BASE_URL;


export default serverURL